// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EsYQj","col":"styles_col__3gidd"};